import { render, staticRenderFns } from "./myCommsPage.vue?vue&type=template&id=48b26772&scoped=true"
import script from "./myCommsPage.vue?vue&type=script&lang=ts"
export * from "./myCommsPage.vue?vue&type=script&lang=ts"
import style0 from "./myCommsPage.vue?vue&type=style&index=0&id=48b26772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b26772",
  null
  
)

export default component.exports